import { useAtom } from "jotai";
import { backendDataAtom } from "atoms/backendDataAtom.js";
import { backendPatch } from "@accredo/fe-shared/services/dataService.js";
import { useSnackbar } from "notistack";
import { updateListItemState } from "./listStateHelpers.js";

export function useContractActions() {
  const [backendData, setBackendData] = useAtom(backendDataAtom);
  const { enqueueSnackbar } = useSnackbar();

  const state =
    backendData?.type === "contract-list"
      ? backendData
      : { data: [], meta: {} };

  const setState = (data) => {
    setBackendData({
      type: "contract-list",
      data: data,
    });
  };

  const updateAssignedClerk = async (contract_id, form_data) => {
    return await backendPatch(`data/vertrags/${contract_id}/assigned-clerk`, {
      label: "Sachbearbeiter",
      toSend: form_data,
      enqueueSnackbar,
      successMessage: "Sachbearbeiter wurde aktualisiert.",
      setResult: (res) => {
        const updated_contract = res?.data ?? res;
        updateListItemState(backendData, setBackendData, updated_contract);
      },
    });
  };

  const replaceAssignedClerkGlobally = async (form_data) => {
    return await backendPatch(`data/vertrags/assigned-clerk/replace`, {
      label: "Sachbearbeiter",
      toSend: form_data,
      enqueueSnackbar,
      successMessage: "Sachbearbeiter wurde global ersetzt.",
    });
  };

  return {
    replaceAssignedClerkGlobally,
    updateAssignedClerk,
    setState,
    state,
  };
}
